import { DepartmentScheduleIntervalResponse } from "./DepartmentScheduleIntervalResponse";

export class DepartmentScheduleRequest {
    id: number;
    departmentId: number;
    scheduleDayList: Array<string>; //list of [yyyy-mm-dd]
    scheduleStartHour: string; // format hh:mm
    scheduleEndHour: string; // format hh:mm
    appointmentDuration: number; //minutes
    selectedMonth: number; // the current selected month in calendar
    selectedYear: number; //the current selected year in calendar
    intervals: DepartmentScheduleIntervalResponse[];
}